<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <v-card flat>
          <div class="text-center mt-4">
            <v-chip
              v-for="(item, i) in regions"
              :key="i"
              class="ma-2"
              color="primary"
              >{{ item.ll_region }}</v-chip
            >
          </div>

          <v-card-actions>
            <v-container fluid>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-menu
                    v-model="menuStart"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedStart"
                        label="Début"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="start"
                      no-title
                      @input="menuStart = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="my-0 py-0">
                  <v-menu
                    v-model="menuEnd"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedEnd"
                        label="Fin"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="end"
                      no-title
                      @input="menuEnd = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    @change="buildrequest()"
                    v-model="projetSelected"
                    :items="projets"
                    outlined
                    dense
                    label="Projets"
                    item-text="ll_programme"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    @change="buildrequest()"
                    v-model="activiteSelected"
                    :items="activitesFiltered"
                    outlined
                    dense
                    label="Activites"
                    item-text="ll_parcours"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    style="width: 390px;"
                    @change="buildrequest()"
                    v-model="animateurSelected"
                    :items="animateursDeProjets"
                    outlined
                    dense
                    label="Animateurs"
                    item-text="displayName"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-right my-0 py-0">
                  <v-btn
                    class="mr-4"
                    color="primary"
                    @click="getFormationsDeGroupesderegions(regionSupervisees)"
                    :loading="loading"
                  >
                    Afficher Formations
                  </v-btn>
                  <v-btn
                    v-if="isSuperviseur"
                    color="info"
                    @click="
                      getMembresPresentsFormationsDeGroupesderegions(
                        regionSupervisees
                      )
                    "
                    :loading="loading"
                  >
                    Afficher membres
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
          <v-card-text>
            <!--    {{ query.sn.K }}  -->
            <template>
              <div class="text-center">
                <v-dialog v-model="dialogEditFormation" width="500">
                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Edition de la formation
                    </v-card-title>

                    <v-card-text>
                      <v-form>
                        <v-text-field
                          v-model="formationSelected.ll_formation_groupe"
                          label="Formation"
                        ></v-text-field>

                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="computedDateFormation"
                              label="Date de la Formation"
                              prepend-icon="mdi-calendar-cursor"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            locale="fr"
                            v-model="formationSelected.date_formation_groupe"
                            no-title
                            @input="menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-btn
                        rounded
                        color="warning"
                        @click="closeDialogEditFormation()"
                        >Annuler</v-btn
                      >
                      <v-btn rounded color="success" @click="doEditFormation()"
                        >Sauvegarder</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </template>
            <vue-excel-xlsx
              class="mr-4"
              v-if="formationsDeGroupeRegion.length > 0"
              :data="formationsDeGroupeRegion"
              :columns="headers"
              :filename="'formations_' + Date.now()"
              :sheetname="'formations'"
            >
              <v-btn class="primary" dark>
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Télécharger les
                {{ formationsDeGroupeRegion.length }} formations</v-btn
              >
            </vue-excel-xlsx>
            <vue-excel-xlsx
              v-if="MembresFormationsDeGroupeRegion.length > 0"
              :data="MembresFormationsDeGroupeRegion"
              :columns="headersMembres"
              :filename="'membres_formations_' + Date.now()"
              :sheetname="'membres_formations_'"
            >
              <v-btn class="info" dark>
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Télécharger les
                {{ MembresFormationsDeGroupeRegion.length }} membres</v-btn
              >
            </vue-excel-xlsx>

            <v-tabs v-model="tab" class="elevation-0">
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#formations">
                Formations
              </v-tab>

              <v-tab href="#membres" v-if="user.role == 'regionalFull'">
                Membres
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item value="formations">
                <!-- limit  -->
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Rechercher"
                  single-line
                  hide-details
                  class="mb-4"
                ></v-text-field>

                <template>
                  <div class="text-center" v-if="formationSelectionnee">
                    <v-dialog
                      v-model="dialogCheckGroupe"
                      width="500"
                      persistent
                    >
                      <v-card>
                        <v-card-title class="text-h5 grey lighten-2">
                          {{ formationSelectionnee.ll_formation_groupe }}
                        </v-card-title>

                        <v-card-text>
                          From Formation:
                          {{ formationSelectionnee.nom_responsable }}
                        </v-card-text>
                        <v-card-text>
                          From groupe :
                          {{ groupeFromFormation.nom_responsable }}
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions
                          v-if="
                            formationSelectionnee.responsable ===
                            groupeFromFormation.responsable
                          "
                        >
                          <v-spacer></v-spacer>
                          <v-btn color="primary" rounded @click="fermer()">
                            fermer
                          </v-btn>
                        </v-card-actions>
                        <v-card-actions v-else>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" rounded @click="fermer()">
                            Annuler
                          </v-btn>
                          <v-btn
                            color="red"
                            dark
                            rounded
                            @click="
                              reparerFormation(
                                formationSelectionnee,
                                groupeFromFormation
                              )
                            "
                          >
                            réparer
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </template>
                <v-data-table
                  :headers="headers"
                  :items="formationsDeGroupeRegion"
                  :items-per-page="20"
                  class="elevation-1"
                  :search="search"
                  locale="fr"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-container style="width: 300px;">
                      <v-row no-gutters>
                        <v-col
                          class="mx-1"
                          style="flex-grow: 0;"
                          v-if="user.role == 'regionalFull'"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="checkGroupe(item)"
                                class="mr-2"
                                fab
                                dark
                                x-small
                                color="red"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon dark>
                                  mdi-account-multiple-check
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Check groupe</span>
                          </v-tooltip>
                        </v-col>

                        <v-col
                          class="mx-1"
                          style="flex-grow: 0;"
                          v-if="user.role == 'regionalFull'"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="editFormation(item)"
                                class="mr-2"
                                fab
                                dark
                                x-small
                                color="blue"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon dark>
                                  mdi-pencil
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Editer la formation</span>
                          </v-tooltip>
                        </v-col>
                        <v-col
                          class="mx-1"
                          style="flex-grow: 0;"
                          v-if="user.role == 'regionalFull'"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                @click="checkFormation(item)"
                                class="mr-2"
                                fab
                                dark
                                x-small
                                color="orange"
                              >
                                <v-icon dark>
                                  mdi-sync-alert
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Vérifier formation</span>
                          </v-tooltip>
                        </v-col>
                        <v-col
                          class="mx-1"
                          style="flex-grow: 0;"
                          v-if="user.role == 'regionalFull'"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="deleteFormationAndPresence(item)"
                                class="mr-2"
                                fab
                                dark
                                x-small
                                color="danger"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon dark>
                                  mdi-trash-can
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Effacer la formation et ses présences</span>
                          </v-tooltip>
                        </v-col>
                        <v-col
                          class="mx-1"
                          style="flex-grow: 0;"
                          v-if="user.role == 'regionalFull' || isOperateur"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="gotoPresenceFormationDeGroupe(item)"
                                class="mx-0"
                                fab
                                dark
                                x-small
                                color="green"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>
                                  mdi-chevron-right
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Détails de la formation (présence)</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>


                  
                </v-data-table>
                <!-- limit  -->
              </v-tab-item>

              <v-tab-item value="membres">
                <v-data-table
                  :headers="headersMembres"
                  :items="MembresFormationsDeGroupeRegion"
                  :items-per-page="20"
                  class="elevation-1"
                  :search="search"
                  locale="fr"
                >
                  <template v-slot:item.sexe="{ item }">
                    {{ getSexe(item.sexe) }}
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  watch: {
    projetSelected: function (val) {
      let activitesFiltered = _.filter(this.activites, {
        programmes_id_programme: val,
      });
      this.activitesFiltered = activitesFiltered;
    },
  },
  created() {
    this.SetProjectList();
    this.getAnimateurs(this.regionSupervisees);
    this.getDetailsRegionsSupervisees(this.listeRegionsSupervisees);
    this.getProjets();
    this.getActivites();
  },
  data() {
    return {
      ProjetctList: [],
      tab: "formations",
      search: "",
      dialogEditFormation: false,
      dialogCheckGroupe: false,
      formationSelected: { ll_formation_groupe: "", date_formation_groupe: "" },
      menu2: false,
      regions: [],
      query: { sn: { K: {} } },
      request: { projets: null, animateurs: null, activites: null },
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      loading: false,
      menuStart: false,
      menuEnd: false,
      start: this.$moment(Date.now()).subtract(1, "year").format("YYYY-MM-DD"),
      end: this.$moment(Date.now()).format("YYYY-MM-DD"),
      headers: [
        {
          text: "Actions",
          value: "actions",
        },
        {
          text: "Date Fusion",
          value: "dateFusion",
          label: "Date Fusion",
          field: "dateFusion",
        },
        {
          text: "Formation",
          value: "ll_formation_groupe",
          label: "Formation",
          field: "ll_formation_groupe",
        },
        {
          text: "Date",
          value: "date_formation_groupe",
          label: "Date",
          field: "date_formation_groupe",
        },
        {
          text: "Vérification",
          value: "lastChecked",
          label: "Vérification",
          field: "lastChecked",
        },
        {
          text: "Groupe",
          value: "nom_groupe",
          label: "Groupe",
          field: "nom_groupe",
        },

        /*   {
          text: "ID de Groupe",
          value: "groupes_code_groupe",
          label: "ID de Groupe",
          field: "groupes_code_groupe",
        },
 */
        {
          text: "Nb membres Actifs",
          value: "nombreMembres",
          label: "Nb membres Actifs",
          field: "nombreMembres",
        },
        {
          text: "Nb Présents",
          value: "presence",
          label: "Nb Présents",
          field: "presence",
        },

        {
          text: "Totaux Femmes",
          value: "nbFemme",
          label: "Femmes",
          field: "nbFemme",
        },
        {
          text: "Totaux Hommes",
          value: "nbHomme",
          label: "Hommes",
          field: "nbHomme",
        },

        {
          text: "Détails Femmes",
          value: "nbDetailFemme",
          label: "Détails Femmes",
          field: "nbDetailFemme",
        },
        {
          text: "Détails Hommes",
          value: "nbDetailHomme",
          label: "Détails Hommes",
          field: "nbDetailHomme",
        },

        {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        },
        {
          text: "Projet",
          value: "ll_programme",
          label: "Projet",
          field: "ll_programme",
        },
        {
          text: "Activité",
          value: "ll_parcours",
          label: "Activité",
          field: "ll_parcours",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
      ],
      headersMembres: [
        {
          text: "ID",
          value: "membres_id_membre",
          label: "ID",
          field: "membres_id_membre",
        },
        {
          text: "Nom",
          value: "nom",
          label: "Nom",
          field: "nom",
        },
        {
          text: "Sexe",
          value: "sexe",
          label: "Sexe",
          field: "sexe",
          dataFormat: this.getSexe,
        },
        {
          text: "Groupe",
          value: "nom_groupe",
          label: "Groupe",
          field: "nom_groupe",
        },

        {
          text: "Formation",
          value: "ll_formation_groupe",
          label: "Formation",
          field: "ll_formation_groupe",
        },
        {
          text: "Date",
          value: "date_formation_groupe",
          label: "Date",
          field: "date_formation_groupe",
        },

        {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        },
        {
          text: "Projet",
          value: "ll_programme",
          label: "Projet",
          field: "ll_programme",
        },
        {
          text: "Activité",
          value: "ll_parcours",
          label: "Activité",
          field: "ll_parcours",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
      ],
      formationsDeGroupeRegion: [],
      MembresFormationsDeGroupeRegion: [],
      projetSelected: null,
      animateurSelected: null,
      activiteSelected: null,
      activitesFiltered: [],
      formationSelectionnee: null,
      groupeFromFormation: null,
    };
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    ...mapActions({
      GetArrayRegions: "Utils/GetArrayRegions",
      getAnimateurs: "Users/getAnimateurs",
      getActivites: "Activites/GetAll",
      getProjets: "Projets/getListeProjets",
    }),

    SetProjectList() {
      this.ProjetctList = Array.isArray(this.user.projets)
        ? this.user.projets.map((projet) => projet.id)
        : [];
    },

    checkGroupe(item) {
      let self = this;
      console.log(item);
      //getGroupDetailsfromId
      //groupeFromFormation
      //groupes_code_groupe
      var docRef = this.$firebase
        .firestore()
        .collection("groupes")
        .doc(item.groupes_code_groupe);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());

            self.groupeFromFormation = doc.data();
            self.dialogCheckGroupe = true;
            self.formationSelectionnee = item;
          } else {
            // doc.data() will be undefined in this case
            console.log(
              "No such document! pas de groupe correspondant:",
              item.groupes_code_groupe
            );
            self.$confirm("Ce groupe n'existe plus").then((res) => {
              if (res) {
                self.formationSelectionnee = null;
              }
            });
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
    fermer() {
      this.dialogCheckGroupe = false;
      this.formationSelectionnee = null;
    },
    reparerFormation(formationSelectionnee, groupeFromFormation) {
      var self = this;
      //console.log("formationSelectionnee", formationSelectionnee);
      //console.log("groupeFromFormation", groupeFromFormation);
      var objet = {
        nom_responsable: groupeFromFormation.nom_responsable,
        responsable: groupeFromFormation.responsable,
      };

      //console.log("objet :", objet);
      //console.log("formationSelectionnee :", formationSelectionnee.id);

      //réparer Formation
      var batch = this.$firebase.firestore().batch();
      batch.set(
        this.$firebase
          .firestore()
          .collection("formationsDeGroupe")
          .doc(formationSelectionnee.id),
        objet,
        { merge: true }
      );
      //réparer présences de la Formation

      batch.commit().then(() => {
        /** update presencesFormationsGroupes */
        const presencesFormationsGroupes = self.$firebase

          .firestore()
          .collection("presencesFormationsGroupes");
        presencesFormationsGroupes
          .where(
            "formations_groupes_id_formation_groupe",
            "==",
            formationSelectionnee.id
          )
          .get()
          .then((snapshots) => {
            console.log("Presences Formations De groupe successfully updated!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                presencesFormationsGroupes
                  .doc(snap.id)
                  .set(objet, { merge: true });
              });
            } else {
              console.log("no snap presencesFormationsGroupes");
            }
          });
        /** End update presencesFormationsGroupes */
        this.dialogCheckGroupe = false;
        this.formationSelectionnee = null;
        self.getFormationsDeGroupesderegions(self.regionSupervisees);
      });
    },

    checkFormation(formation) {
      let self = this;
      var idx = this.formationsDeGroupeRegion.indexOf(formation);
      console.log("index :", idx);
      //console.log(formation.id)
      //get Presences de la formation
      var listePresents = [];
      this.$firebase
        .firestore()
        .collection("presencesFormationsGroupes")
        .where("formations_groupes_id_formation_groupe", "==", formation.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listePresents.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          var nbPresents = listePresents.length;
          console.log(nbPresents);

          /**** */
          var lastChecked = self
            .$moment(new Date())
            .format("YYYY-MM-DD HH:mm:ss");
          var formationRef = this.$firebase
            .firestore()
            .collection("formationsDeGroupe")
            .doc(formation.id);
          formationRef
            .update({
              presence: nbPresents,
              lastChecked: lastChecked,
            })
            .then(() => {
              console.log("presence: ", nbPresents);
              self.formationsDeGroupeRegion[idx].presence = nbPresents;
              self.formationsDeGroupeRegion[idx].lastChecked = lastChecked;
              self.formationsDeGroupeRegion.splice(
                idx,
                1,
                self.formationsDeGroupeRegion[idx]
              );

              console.log("Document successfully updated!");
            })
            .catch((error) => {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);
            });
          /*** */
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });

      //console.log(formation.groupes_code_groupe)
      var listeMembres = [];
      this.$firebase
        .firestore()
        .collection("membres")
        .where("id_groupe", "==", formation.groupes_code_groupe)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listeMembres.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          var listeMembresActif = _.filter(listeMembres, {
            actif_dans_groupe: 1,
          });
          var nombreMembresActifs = listeMembresActif.length;
          console.log(nombreMembresActifs);

          /**** */
          var formationRef = this.$firebase
            .firestore()
            .collection("formationsDeGroupe")
            .doc(formation.id);
          formationRef
            .update({
              nombreMembres: nombreMembresActifs,
            })
            .then(() => {
              console.log("nombreMembres : ", nombreMembresActifs);
              self.formationsDeGroupeRegion[
                idx
              ].nombreMembres = nombreMembresActifs;
              console.log(
                "ligne modifiée: ",
                self.formationsDeGroupeRegion[idx]
              );
              self.formationsDeGroupeRegion.splice(
                idx,
                1,
                self.formationsDeGroupeRegion[idx]
              );
              console.log("Document successfully updated!");
            })
            .catch((error) => {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);
            });
          /*** */
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
      //Get Membres Actifs de groupes de la formation

      //self.getFormationsDeGroupesderegions(self.regionSupervisees)
      console.log("vita");
    },

    //edition et suppression de formation
    gotoPresenceFormationDeGroupe(item) {
      this.$router.push({
        path: `/groupes/presenceFormationGroupe/${item.id}`,
        query: {
          projet: item.programmes_id_programme,
          ll_formation_groupe: item.ll_formation_groupe,
          idAnimateur: item.responsable,
          id_groupe: item.groupes_code_groupe,
        },
      });
    },

    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },

    editFormation(item) {
      console.log("editFormation", item);
      this.dialogEditFormation = true;
      this.formationSelected = item;
    },
    doEditFormation() {
      var self = this;
      var id = this.formationSelected.id;
      var lobjet = {
        ll_formation_groupe: self.formationSelected.ll_formation_groupe,
        date_formation_groupe: self.formationSelected.date_formation_groupe,
      };
      //Modifier Formation:
      var ref = this.$firebase
        .firestore()
        .collection("formationsDeGroupe")
        .doc(this.formationSelected.id);

      ref
        .set(lobjet, { merge: true })
        .then(() => {
          console.log("Formation modified ID: ", id);
          // Modifier Présences de la formation

          const PresencesFormations = self.$firebase
            .firestore()
            .collection("presencesFormationsGroupes");
          PresencesFormations.where(
            "formations_groupes_id_formation_groupe",
            "==",
            id
          )
            .get()
            .then((snapshots) => {
              console.log("PresencesFormations successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  PresencesFormations.doc(snap.id).set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap presencesFormationsGroupes");
              }
            });
        })
        .catch((error) => {
          console.error("Error Editing document: ", error);
        });

      this.closeDialogEditFormation();
    },
    closeDialogEditFormation() {
      this.formationSelected = {
        ll_formation_groupe: "",
        date_formation_groupe: "",
      };
      this.dialogEditFormation = false;
    },
    deleteFormationAndPresence(item) {
      let self = this;
      var id = item.id;
      var idGroupe = item.groupes_code_groupe;
      const PresencesFormations = self.$firebase
        .firestore()
        .collection("presencesFormationsGroupes");
      this.$confirm(
        "Voulez vous vraiment supprimer la formation : <strong>" +
          item.ll_formation_groupe +
          "</strong> ?, et sa fiche de présence ?"
      ).then((res) => {
        if (res) {
          console.log("deleteFormationAndPresence", item);
          var ref = this.$firebase
            .firestore()
            .collection("formationsDeGroupe")
            .doc(item.id);

          ref
            .delete()
            .then(() => {
              PresencesFormations.where(
                "formations_groupes_id_formation_groupe",
                "==",
                id
              )
                .get()
                .then((snapshots) => {
                  console.log("PresencesFormations successfully deleted!");
                  if (snapshots.size > 0) {
                    snapshots.forEach((snap) => {
                      PresencesFormations.doc(snap.id).delete();
                    });
                  } else {
                    console.log("no snap presencesFormationsGroupes");
                  }
                });
              self.getFormationsDeGroupesderegions(self.regionSupervisees);
            })
            .catch((error) => {
              console.error("Error removing document: ", error);
            });
        }
      });
    },
    // fin edition et suppression de formation
    buildrequest() {
      this.request.projets = this.projetSelected;
      this.request.animateurs = this.animateurSelected;
      this.request.activites = this.activiteSelected;
      console.log("request :", this.request);
    },
    setActivites() {
      console.log("setActivites");
    },
    getDetailsRegionsSupervisees(regionSupervisees) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("regions")
        .where("id", "in", regionSupervisees)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.regions.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          console.log(self.regions);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    getFormationsDeGroupesderegions(arrayRegions) {
      let self = this;
      self.formationsDeGroupeRegion = [];
      self.$vloading.show();

      var ref = this.$firebase.firestore().collection("formationsDeGroupe");
      let query = ref
        .where("id_region", "in", arrayRegions)
        .where("date_formation_groupe", ">=", self.start)
        .where("date_formation_groupe", "<=", self.end);

      //Animateur
      console.log("Animateur ****** :", this.request.animateurs);
      if (this.request.animateurs) {
        query = query.where(
          "responsable",
          "==",
          this.request.animateurs.toString()
        );
        console.log("Animateur :", this.request.animateurs);
      }
      //Activites
      if (this.request.activites) {
        console.log("activiteSelected : ", this.activiteSelected);
        query = query.where(
          "parcours_id_parcours",
          "==",
          this.request.activites.toString()
        );
      } else {
        //Projet
        if (this.request.projets) {
          query = query.where(
            "programmes_id_programme",
            "==",
            this.request.projets.toString()
          );
          console.log("Projets :", this.request.projets);
        }
      }

      self.query = query.xd;
      //query final
      const results = query
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.formationsDeGroupeRegion.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          //self.request = { projets: null, animateurs: null, activites: null };
          /*  self.projetSelected = null;
          self.animateurSelected = null;
          self.activiteSelected = null; */
          self.$vloading.hide();
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    getMembresPresentsFormationsDeGroupesderegions(arrayRegions) {
      let self = this;
      self.MembresFormationsDeGroupeRegion = [];
      self.$vloading.show();
      var ref = this.$firebase
        .firestore()
        .collection("presencesFormationsGroupes");
      let query = ref
        .where("id_region", "in", arrayRegions)
        .where("date_formation_groupe", ">=", self.start)
        .where("date_formation_groupe", "<=", self.end);

      //Animateur
      console.log("Animateur :", this.request.animateurs);
      if (this.request.animateurs) {
        query = query.where(
          "id_responsable",
          "==",
          this.request.animateurs.toString()
        );
        console.log("Animateur :", this.request.animateurs);
      }
      //Activites
      if (this.request.activites) {
        console.log("activiteSelected : ", this.activiteSelected);
        query = query.where(
          "parcours_id_parcours",
          "==",
          this.request.activites.toString()
        );
      } else {
        //Projet
        if (this.request.projets) {
          query = query.where(
            "programmes_id_programme",
            "==",
            this.request.projets.toString()
          );
          console.log("Projets :", this.request.projets);
        }
      }

      //query final
      query
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.MembresFormationsDeGroupeRegion.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          self.tab = "membres";
          self.$vloading.hide();
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
  },

  computed: {
    computedDateFormation() {
      return this.formationSelected.date_formation_groupe
        ? this.$moment(this.formationSelected.date_formation_groupe).format(
            "DD-MM-YYYY"
          )
        : "";
    },
    computedStart() {
      return this.start ? this.start : "";
    },
    computedEnd() {
      return this.end ? this.end : "";
    },
    ...mapState({
      user: (state) => state.Auth.user,
      //projets: (state) => state.Projets.projets,
      projets: (state) => state.Auth.user.projets,
      activites: (state) => state.Activites.Activites,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      animateursDeRegions: (state) => state.Users.animateursDeRegions,
      listeRegionsSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isOperateur: (state) => state.Auth.isOperateur,
      animateursDeProjets(state) {
        return state.Users.animateursDeRegions.filter((u) => {
          const projets = Array.isArray(u.projets) ? u.projets : [];
          return projets.some((d) => _.includes(this.ProjetctList, d.id));
        });
      },
    }),
  },
};
</script>

<style lang="scss" scoped></style>
